define('app/views/gallery',['require','./page'],function(require){

  var Page = require('./page');

  return Page.extend({

    view: 'gallery',

    events: {
      'click .carousel-prev,.carousel-next': 'onClickCarouselArrow'
    },

    afterShow: function(){
      _.bindAll(this, 'onClickCarouselArrow');

      Page.prototype.afterShow.call(this);
      $(document).on('keydown.overlay', this.onKeyDown);
    },

    afterHide: function(){
      Page.prototype.afterHide.call(this);
      $(document).off('keydown.overlay');
    },

    onKeyDown: function(e){
      var carousel = $('.carousel', this.$el).data().instance;
      if(e.keyCode == 37){
        carousel.previous();
      } else if(e.keyCode == 39){
        carousel.next();
      }
    },

    onClickCarouselArrow: function(e){
      var carousel = $('.carousel', this.$el).data().instance;
      carousel.option('autoPlay', false);
    }

  });

});
